import { instance } from '@/services/avik-api-gateway'
import { VehicleWithdrawalDepot } from '@/types/vehicle-withdrawal-depot'
import { AxiosResponse } from 'axios'

export function createVehicleWithdrawalDepot(
  body: Partial<VehicleWithdrawalDepot>
): Promise<AxiosResponse<VehicleWithdrawalDepot>> {
  return instance.post(`/vehicle-withdrawal-depot`, body)
}
